// import React, { useEffect, useMemo, useState } from "react";
// import Header from "./Header";
// import Footer from "./Footer";
// import axios from "axios";
// import { Row, Col, Card, Nav, Form } from "react-bootstrap";
// import { Helmet } from "react-helmet";

// const API_URL =
//   "https://api.carnivalcastle.com/v1/carnivalApi/web/category/getcakes";
// const BASE_URL = "https://api.carnivalcastle.com/";

// function Enquiry() {
//   const [premiumCakes, setPremiumCakes] = useState([]);
//   const [normalCakes, setNormalCakes] = useState([]);
//   const [activeTab, setActiveTab] = useState("premium");
//   const [cakeType, setCakeType] = useState("egg");
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     loadCakes();
//   }, []);

//   const loadCakes = async () => {
//     try {
//       setLoading(false);
//       const res = await axios.post(API_URL);
//       if (res.data.success) {
//         setPremiumCakes(res.data.premiumCakes || []);
//         setNormalCakes(res.data.normalCakes || []);
//       }
//     } catch (e) {
//       console.error(e);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const cakesToShow = useMemo(() => {
//     const source = activeTab === "premium" ? premiumCakes : normalCakes;
//     return source.filter((c) => c.cakeType === cakeType);
//   }, [activeTab, cakeType, premiumCakes, normalCakes]);

//   return (
//     <>
//       <Helmet>
//         <title>Cakes | Carnival Castle</title>
//       </Helmet>

//       {loading ? (
//         <div className="vh-100 d-flex flex-column justify-content-center align-items-center bg-dark">
//           <img src="assets/img/gipss.gif" height="260" />
//           <p className="text-warning mt-2">Loading cakes...</p>
//         </div>
//       ) : (
//         <div className="home-page indexsix">
//           <Header />
//           <div className="">

//             <main className="main-wrapper">
//               {/* Title */}
//               <section className="cakes-hero">
//                 <h1>Cakes Collection</h1>
//                 <p>Premium & Standard cakes for every celebration</p>
//               </section>

//               {/* Controls */}
//               <section className="cakes-controls">
//                 <div className="container">
//                   <Row className="align-items-center">
//                     <Col md={6}>
//                       <Nav
//                         variant="pills"
//                         activeKey={activeTab}
//                         onSelect={(k) => setActiveTab(k)}
//                         className="cakes-tabs"
//                       >
//                         <Nav.Item>
//                           <Nav.Link eventKey="premium">
//                             Premium Cakes
//                           </Nav.Link>
//                         </Nav.Item>
//                         <Nav.Item>
//                           <Nav.Link eventKey="normal">
//                             Standard Cakes
//                           </Nav.Link>
//                         </Nav.Item>
//                       </Nav>
//                     </Col>

//                     {/* TOGGLE AT END */}
//                     {/* <Col
//                       md={6}
//                       className="d-flex justify-content-md-end justify-content-start mt-3 mt-md-0"
//                     >
//                       <div className="d-flex align-items-center gap-2 cake-toggle">
//                         <span className={cakeType === "egg" ? "fw-bold lightest-text" : ""}>
//                           Egg
//                         </span>

//                         <Form.Check
//                           type="switch"
//                           id="cake-type"
//                           checked={cakeType === "eggless"}
//                           onChange={() =>
//                             setCakeType(cakeType === "egg" ? "eggless" : "egg")
//                           }
//                         />

//                         <span
//                           className={cakeType === "eggless" ? "fw-bold lightest-text" : ""}
//                         >
//                           Eggless
//                         </span>
//                       </div>
//                     </Col> */}
//                   </Row>
//                 </div>
//               </section>

//               {/* Cakes */}
//               <section className="cakes-grid">
//                 <div className="container">
//                   {cakesToShow.length === 0 ? (
//                     <div className="text-center py-5 text-muted">
//                       No cakes available
//                     </div>
//                   ) : (
//                     <Row>
//                       {cakesToShow.map((cake, i) => (
//                         <Col
//                           key={i}
//                           xl={2}
//                           lg={3}
//                           md={4}
//                           sm={6}
//                           xs={6}
//                           className="mb-4"
//                         >
//                           <Card className="cake-card">
//                             <div className="cake-image">
//                               <img
//                                 src={BASE_URL + cake.image}
//                                 alt={cake.name}
//                               />
//                             </div>

//                             <Card.Body className="text-center">
//                               <h6 className="cake-name">{cake.name}</h6>
//                               <div className="cake-price">
//                                 ₹ {cake.price}
//                               </div>
//                             </Card.Body>
//                           </Card>
//                         </Col>
//                       ))}

//                       {activeTab === "premium" && (
//                         <div className="premium-note">
//                           <b>Note:</b> Customized premium cakes must be ordered
//                           at least <b>3 days in advance</b>.
//                         </div>
//                       )}
//                     </Row>
//                   )}
//                 </div>
//               </section>
//             </main>
//           </div>

//           <Footer />
//         </div>
//       )}

//       {/* STYLES */}
//       <style>{`
//         .cakes-page {
//           background: #f7f8fc;
//           min-height: 100vh;
//         }

//         .cakes-hero {
//           background: linear-gradient(135deg, #ffffff, #f3f4ff);
//           text-align: center;
//         }

//         .cakes-controls {
//           background: #ffffff;
//           position: sticky;
//           top: 0;
//           z-index: 20;
//           border-bottom: 1px solid #eee;
//           padding: 15px 0;
//         }

//         .cakes-tabs .nav-link {
//           border-radius: 30px;
//           padding: 8px 20px;
//           font-weight: 600;
//         }

//         .cake-toggle span {
//           font-size: 16px;
//         }

//         .cakes-grid {
//           padding: 30px 0;
//         }

//         .cake-card {
//           border: none;
//           border-radius: 18px;
//           background: #ffffff;
//           height: 100%;
//           box-shadow: 0 12px 30px rgba(0, 0, 0, 0.08);
//           transition: all 0.3s ease;
//         }

//         .cake-card:hover {
//           transform: translateY(-6px);
//           box-shadow: 0 20px 45px rgba(0, 0, 0, 0.15);
//         }

//         .cake-image {
//           height: 160px;
//           overflow: hidden;
//           border-radius: 18px 18px 0 0;
//         }

//         .cake-image img {
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//         }

//         .cake-name {
//           font-weight: 600;
//           margin-bottom: 6px;
//         }

//         .cake-price {
//           font-size: 18px;
//           font-weight: 800;
//           color: #9D4DFF;
//         }

//         .premium-note {
//           margin-top: 20px;
//           background: #fff3cd;
//           padding: 15px;
//           border-radius: 12px;
//         }
//       `}</style>
//     </>
//   );
// }

// export default Enquiry;


import React, { useEffect, useMemo, useState, memo } from "react";
import Header from "./Header";
import Footer from "./Footer";
import axios from "axios";
import { Helmet } from "react-helmet";

const API_URL  = "https://api.carnivalcastle.com/v1/carnivalApi/web/category/getcakes";
const BASE_URL = "https://api.carnivalcastle.com/";

const C = {
  primary:"#5E0E73", primaryLight:"#6E1A85", primaryDeep:"#3A0847",
  primaryPale:"#F3E5F7", cream:"#E8E1D6", beige:"#D6CFC4",
  gold:"#C9A84C", goldLight:"#E8D5A0", goldBright:"#F5D87A",
  dark:"#1A0030", dark2:"#120020",
};

/* ── Scroll reveal ── */
const ScrollReveal = memo(() => {
  useEffect(() => {
    const o = new IntersectionObserver(
      e => e.forEach(x => { if (x.isIntersecting) x.target.classList.add("ck-in"); }),
      { threshold: 0.07 }
    );
    const run = () => document.querySelectorAll(".ck-rv:not(.ck-in)").forEach(el => o.observe(el));
    run(); const t = setTimeout(run, 500);
    return () => { o.disconnect(); clearTimeout(t); };
  }, []);
  return null;
});

export default function Cakes() {
  const [premiumCakes, setPremiumCakes] = useState([]);
  const [normalCakes,  setNormalCakes]  = useState([]);
  const [activeTab,    setActiveTab]    = useState("premium");
  const [loading,      setLoading]      = useState(true);

  useEffect(() => {
    axios.post(API_URL)
      .then(res => {
        if (res.data.success) {
          setPremiumCakes(res.data.premiumCakes || []);
          setNormalCakes(res.data.normalCakes  || []);
        }
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  /* all cakes for active tab (no egg/eggless filter visible) */
  const cakesToShow = useMemo(() =>
    activeTab === "premium" ? premiumCakes : normalCakes,
    [activeTab, premiumCakes, normalCakes]
  );

  /* ── Loading ── */
  if (loading) return (
    <div style={{ background:C.dark, height:"100vh", display:"flex", alignItems:"center", justifyContent:"center", flexDirection:"column", gap:18 }}>
      <div style={{ width:68, height:68, border:`4px solid ${C.primaryPale}`, borderTop:`4px solid ${C.gold}`, borderRadius:"50%", animation:"_spin 1s linear infinite" }}/>
      <p style={{ color:C.gold, fontWeight:600, letterSpacing:2, fontSize:14 }}>Loading Cakes…</p>
      <style>{`@keyframes _spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );

  return (
    <>
      <Helmet>
        <title>Cakes Collection | Carnival Castle</title>
        <meta name="description" content="Premium & standard celebration cakes for birthdays, anniversaries and every special occasion at Carnival Castle Hyderabad."/>
      </Helmet>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,600;0,700;0,900;1,600&family=DM+Sans:wght@300;400;500;600;700&display=swap');
        :root{--p:${C.primary};--pl:${C.primaryLight};--pd:${C.primaryDeep};--pp:${C.primaryPale};--cream:${C.cream};--gold:${C.gold};--gl:${C.goldLight};--gb:${C.goldBright};--dark:${C.dark};--dark2:${C.dark2};}
        *,*::before,*::after{box-sizing:border-box;}
        .ck-root,.ck-root *{font-family:'DM Sans',sans-serif;}
        .pf{font-family:'Playfair Display',serif!important;}

        @keyframes ck-fadeUp  {from{opacity:0;transform:translateY(36px)}to{opacity:1;transform:translateY(0)}}
        @keyframes ck-goldBg  {0%,100%{background-position:0% 50%}50%{background-position:100% 50%}}
        @keyframes ck-shine   {0%{left:-100%}25%{left:130%}100%{left:130%}}
        @keyframes ck-ticker  {from{transform:translateX(0)}to{transform:translateX(-50%)}}
        @keyframes ck-float   {0%,100%{transform:translateY(0)}50%{transform:translateY(-10px)}}

        .ck-rv{opacity:0;transform:translateY(28px);transition:opacity .65s ease,transform .65s cubic-bezier(.16,1,.3,1);}
        .ck-rv.ck-in{opacity:1;transform:translateY(0);}
        .ck-rv.d1{transition-delay:.05s}.ck-rv.d2{transition-delay:.12s}.ck-rv.d3{transition-delay:.19s}
        .ck-rv.d4{transition-delay:.26s}.ck-rv.d5{transition-delay:.33s}.ck-rv.d6{transition-delay:.40s}

        /* ── Ticker ── */
        .ck-ticker{background:var(--pd);padding:10px 0;overflow:hidden;border-bottom:1px solid rgba(201,168,76,.15);}
        .ck-ticker-track{display:flex;width:max-content;animation:ck-ticker 22s linear infinite;}
        .ck-ticker-item{color:rgba(255,255,255,.6);font-size:11px;font-weight:600;letter-spacing:1px;text-transform:uppercase;padding:0 40px;border-right:1px solid rgba(255,255,255,.1);white-space:nowrap;}

        /* ── Hero ── */
        .ck-hero{
          position:relative;min-height:52vh;overflow:hidden;
          background:linear-gradient(135deg,rgba(26,0,48,.8) 0%,rgba(94,14,115,.55) 50%,rgba(18,0,32,.82) 100%),
            url('https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?w=1200&q=80') center/cover no-repeat;
          display:flex;align-items:center;justify-content:center;text-align:center;
        }
        .ck-hero-orb{position:absolute;border-radius:50%;filter:blur(70px);pointer-events:none;}
        .ck-hero-badge{display:inline-flex;align-items:center;gap:8px;background:rgba(201,168,76,.1);border:1px solid rgba(201,168,76,.32);backdrop-filter:blur(12px);border-radius:60px;padding:8px 20px;color:var(--gold);font-size:12px;font-weight:700;letter-spacing:1px;text-transform:uppercase;margin-bottom:18px;}
        .ck-hero-title{font-family:'Playfair Display',serif;font-size:clamp(36px,6vw,68px);font-weight:900;color:#fff;line-height:1.07;margin-bottom:14px;text-shadow:0 4px 24px rgba(0,0,0,.35);}
        .ck-hero-title span{background:linear-gradient(135deg,var(--gl),var(--cream));-webkit-background-clip:text;-webkit-text-fill-color:transparent;}
        .ck-hero-sub{font-size:clamp(14px,2vw,17px);color:rgba(255,255,255,.65);max-width:480px;margin:0 auto;}

        /* ── Sticky controls bar ── */
        .ck-controls{
          position:sticky;top:0;z-index:50;
          background:rgba(26,0,48,.96);
          backdrop-filter:blur(16px);
          border-bottom:1px solid rgba(201,168,76,.15);
          padding:16px 0;
        }
        .ck-controls-inner{display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:14px;}

        /* tab pills */
        .ck-tabs{display:flex;gap:8px;}
        .ck-tab{
          padding:10px 24px;border-radius:50px;border:1.5px solid rgba(255,255,255,.12);
          background:transparent;color:rgba(255,255,255,.55);
          font-family:'DM Sans',sans-serif;font-size:13px;font-weight:700;
          cursor:pointer;transition:all .25s;white-space:nowrap;
        }
        .ck-tab:hover{border-color:rgba(201,168,76,.4);color:rgba(255,255,255,.8);}
        .ck-tab.active{
          background:linear-gradient(135deg,var(--p),var(--pl));
          border-color:transparent;color:#fff;
          box-shadow:0 6px 20px rgba(94,14,115,.4);
        }

        /* count chip */
        .ck-count{font-size:12px;color:rgba(255,255,255,.35);font-weight:600;letter-spacing:.5px;}
        .ck-count span{color:var(--gold);font-size:16px;font-weight:800;font-family:'Playfair Display',serif;}

        /* ── Grid section ── */
        .ck-grid-sec{padding:60px 0 80px;background:var(--cream);}

        /* ── Cake card ── */
        .ck-card{
          border-radius:22px;overflow:hidden;background:#fff;
          border:1px solid rgba(94,14,115,.08);
          box-shadow:0 4px 22px rgba(94,14,115,.07);
          transition:transform .4s cubic-bezier(.25,1,.5,1),box-shadow .4s;
          cursor:pointer;position:relative;height:100%;
          display:flex;flex-direction:column;
        }
        .ck-card:hover{transform:translateY(-10px);box-shadow:0 24px 56px rgba(94,14,115,.18);}
        .ck-card::after{
          content:'';position:absolute;bottom:0;left:50%;width:0;height:2px;
          background:linear-gradient(90deg,var(--p),var(--gold));
          border-radius:2px;
          transition:width .4s cubic-bezier(.25,1,.5,1),left .4s cubic-bezier(.25,1,.5,1);
        }
        .ck-card:hover::after{width:100%;left:0;}

        .ck-img-wrap{position:relative;height:180px;overflow:hidden;flex-shrink:0;}
        .ck-img{width:100%;height:100%;object-fit:cover;display:block;transition:transform .55s cubic-bezier(.25,1,.5,1);}
        .ck-card:hover .ck-img{transform:scale(1.09);}
        .ck-img-glow{position:absolute;inset:0;background:linear-gradient(to top,rgba(94,14,115,.4) 0%,transparent 55%);opacity:0;transition:opacity .35s;}
        .ck-card:hover .ck-img-glow{opacity:1;}

        /* type badge */
        .ck-type-badge{
          position:absolute;top:10px;left:10px;
          background:rgba(26,0,48,.7);backdrop-filter:blur(8px);
          color:rgba(255,255,255,.8);font-size:9px;font-weight:800;
          letter-spacing:1.5px;text-transform:uppercase;
          padding:3px 10px;border-radius:50px;
          border:1px solid rgba(255,255,255,.12);
        }

        .ck-body{padding:18px 14px 20px;display:flex;flex-direction:column;flex:1;}
        .ck-float-icon{
          position:absolute;top:-15px;left:14px;
          width:32px;height:32px;border-radius:10px;
          background:linear-gradient(135deg,var(--p),var(--pl));
          display:flex;align-items:center;justify-content:center;
          font-size:14px;box-shadow:0 5px 14px rgba(94,14,115,.35);
          transition:transform .3s;
        }
        .ck-card:hover .ck-float-icon{transform:rotate(-8deg) scale(1.1);}
        .ck-name{
          font-family:'Playfair Display',serif;font-size:14px;font-weight:700;
          color:var(--dark);margin:8px 0 6px;line-height:1.3;
          transition:color .25s;
        }
        .ck-card:hover .ck-name{color:var(--p);}
        .ck-line{display:block;width:0;height:2px;background:linear-gradient(90deg,var(--p),var(--gold));border-radius:2px;margin:0 0 10px;transition:width .4s cubic-bezier(.25,1,.5,1);}
        .ck-card:hover .ck-line{width:36px;}
        .ck-price{
          font-family:'Playfair Display',serif;font-size:20px;font-weight:900;
          color:var(--p);line-height:1;margin-top:auto;
        }
        .ck-price small{font-size:12px;font-weight:600;color:#aaa;font-family:'DM Sans',sans-serif;display:block;margin-top:3px;}

        /* ── Note banner ── */
        .ck-note{
          border-radius:18px;
          background:linear-gradient(135deg,rgba(94,14,115,.07),rgba(201,168,76,.06));
          border:1px solid rgba(201,168,76,.25);
          padding:18px 24px;margin-top:36px;
          display:flex;align-items:flex-start;gap:12px;
        }
        .ck-note-icon{font-size:22px;flex-shrink:0;margin-top:2px;}
        .ck-note-text{font-size:13px;color:#555;line-height:1.7;}
        .ck-note-text b{color:var(--p);}

        /* ── Empty state ── */
        .ck-empty{
          text-align:center;padding:72px 20px;
          background:rgba(94,14,115,.04);border-radius:20px;
          border:1px dashed rgba(94,14,115,.15);
        }
        .ck-empty-icon{font-size:52px;opacity:.4;margin-bottom:14px;}
        .ck-empty-txt{color:#888;font-size:15px;}

        /* responsive */
        @media(max-width:768px){
          .ck-hero{min-height:44vh;}
          .ck-grid-sec{padding:40px 0 60px;}
          .ck-controls-inner{justify-content:center;}
          .ck-img-wrap{height:150px;}
        }
        @media(max-width:480px){
          .ck-tab{padding:9px 16px;font-size:12px;}
        }
      `}</style>

      <ScrollReveal/>

      <div className="ck-root">
        <Header/>

        {/* Ticker */}
        <div className="ck-ticker"><div className="ck-ticker-track">
          {[...Array(4)].map((_,k)=>["🎂 Premium Custom Cakes","⭐ Order 3 Days in Advance","🍰 Designer Celebration Cakes","✨ For Every Special Occasion"].map((item,i)=>(
            <span key={`${k}-${i}`} className="ck-ticker-item">{item}</span>
          )))}
        </div></div>

        {/* Hero */}
        <section className="ck-hero">
          <div className="ck-hero-orb" style={{width:480,height:480,background:`radial-gradient(circle,${C.primary}36 0%,transparent 70%)`,top:-80,right:-60}}/>
          <div className="ck-hero-orb" style={{width:280,height:280,background:"radial-gradient(circle,rgba(201,168,76,.1) 0%,transparent 70%)",bottom:40,left:-40}}/>
          <div style={{position:"relative",zIndex:2,animation:"ck-fadeUp .9s cubic-bezier(.16,1,.3,1) both",padding:"0 20px"}}>
            <div className="ck-hero-badge">🎂 Celebration Cakes</div>
            <h1 className="ck-hero-title pf">Our <span>Cakes</span> Collection</h1>
            <p className="ck-hero-sub">Premium & standard cakes crafted for every celebration — birthdays, anniversaries, proposals and more.</p>
          </div>
        </section>

        {/* Sticky Controls */}
        <div className="ck-controls">
          <div className="container">
            <div className="ck-controls-inner">
              <div className="ck-tabs">
                <button className={`ck-tab${activeTab==="premium"?" active":""}`} onClick={()=>setActiveTab("premium")}>
                  👑 Premium Cakes
                </button>
                <button className={`ck-tab${activeTab==="normal"?" active":""}`} onClick={()=>setActiveTab("normal")}>
                  🎂 Standard Cakes
                </button>
              </div>
              <div className="ck-count">
                <span>{cakesToShow.length}</span> cakes available
              </div>
            </div>
          </div>
        </div>

        {/* Grid */}
        <section className="ck-grid-sec">
          <div className="container">
            {cakesToShow.length === 0 ? (
              <div className="ck-empty ck-rv">
                <div className="ck-empty-icon">🎂</div>
                <div className="ck-empty-txt">No cakes available in this category right now.<br/>Check back soon!</div>
              </div>
            ) : (
              <>
                <div className="row g-3">
                  {cakesToShow.map((cake, i) => (
                    <div key={i} className={`col-xl-2 col-lg-3 col-md-4 col-6 ck-rv d${(i%6)+1}`}>
                      <div className="ck-card">
                        <div className="ck-img-wrap">
                          <img src={BASE_URL + cake.image} alt={cake.name} className="ck-img" loading="lazy"/>
                          <div className="ck-img-glow"/>
                          {/* {cake.cakeType && (
                            <span className="ck-type-badge">{cake.cakeType}</span>
                          )} */}
                        </div>
                        <div className="ck-body" style={{position:"relative"}}>
                          <div className="ck-float-icon">🎂</div>
                          <div className="ck-name pf">{cake.name}</div>
                          <span className="ck-line"/>
                          <div className="ck-price pf">
                            ₹{cake.price}
                            <small>Starting price</small>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Premium note */}
                {activeTab === "premium" && (
                  <div className="ck-note ck-rv" style={{transitionDelay:".2s"}}>
                    <div className="ck-note-icon">⏰</div>
                    <div className="ck-note-text">
                      <b>Important:</b> Customized premium cakes must be ordered at least <b>3 days in advance</b> to ensure the best quality and design. Contact us early to secure your celebration cake!
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </section>

        <Footer/>
      </div>
    </>
  );
}